import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ServiceAreasAPI(): BringozApi {
  return {
    base: `/areas`,
    infiniteScroll: {
      address: `/areas`,
      cmd: 'GET'
    },
    actions : {
      getAreasByIds: {
        address : 'byIds',
        cmd : 'POST',
        updateable: true
      },
      searchAreasByAddressGeoLocation : {
        address : 'location',
        cmd : 'GET',
        updateable: false
      },
      create: {
        address : '',
        cmd : 'PUT',
        updateable: false
      },
      deleteOne: {
        address : '{id}',
        cmd : 'DELETE',
        updateable: false
      },
      getAreaNameMap: {
        address : 'names',
        cmd : 'GET',
        updateable: false
      },
      getAreas: {
        address : '',
        cmd : 'GET',
        updateable: false
      },
      branches: {
        address : 'branches',
        cmd : 'POST',
        updateable: false
      },
      getAll: {
        address : 'all',
        cmd : 'GET',
        updateable: false
      },
      getGeoJson: {
        address: 'areas.geojson',
        cmd: 'GET',
        updateable: false
      },
      exportGeoJson: {
        address: 'export/geojson',
        cmd: 'GET',
        updateable: false
      },
      exportKml: {
        address: 'export/kml',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
angular
  .module('bringoz.admin.service-areas')
  .factory('ServiceAreasAPI', ServiceAreasAPI);
